import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { getPaymentStatus } from '../../actions/ordersActions'

export default function OrderResult() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()

    const { orderId } = useParams()

	const {paymentStatus} = useSelector(state=>state.orders)

	useEffect(() => {
		if(orderId){
			dispatch(getPaymentStatus(orderId))
		}
	},[dispatch, orderId])

	return (
		<Container className="contenido client">
			<header></header>
			<Row>
				{
					paymentStatus?.isPaid
					?
							<Col className='text-center'>
								<h1>{t('client.orders.resultTitle')}</h1>
								<label className='sd-label-medium'>{t('client.orders.paymentCorrectLabel')}</label>
							</Col>
					:
						paymentStatus?.paymentResult
						?
							<Col className='text-center'>
								<h1>{t('client.orders.resultTitleError')}</h1>
								<label className='sd-label-medium'>{t('client.orders.paymentErrorLabel')}</label>
							</Col>
						:
							<></>
				}
			</Row>
        </Container>
	)
}